
<template>
	<i>
		<svg width='24' height='24' viewBox='0 0 24 24' fill='none'><path d='M7.99998 3.99999V4.88999L9.99998 6.88999V3.99999H14V7.99999H11.11L13.11 9.99999H14V10.89L16 12.89V9.99999H20V14H17.11L19.11 16H20V16.89L22 18.89V3.99999C22 2.89999 21.1 1.99999 20 1.99999H5.10998L7.10998 3.99999H7.99998ZM16 3.99999H19C19.55 3.99999 20 4.44999 20 4.99999V7.99999H16V3.99999ZM22.16 21.88L2.11998 1.83999C1.72998 1.44999 1.09998 1.44999 0.70998 1.83999C0.31998 2.22999 0.31998 2.85999 0.70998 3.24999L1.99998 4.54999V20C1.99998 21.1 2.89998 22 3.99998 22H19.45L20.75 23.3C21.14 23.69 21.77 23.69 22.16 23.3C22.55 22.91 22.55 22.27 22.16 21.88ZM9.99998 12.55L11.45 14H9.99998V12.55ZM3.99998 6.54999L5.44998 7.99999H3.99998V6.54999ZM7.99998 20H4.99998C4.44998 20 3.99998 19.55 3.99998 19V16H7.99998V20ZM7.99998 14H3.99998V9.99999H7.44998L7.99998 10.55V14ZM14 20H9.99998V16H13.45L14 16.55V20ZM16 20V18.55L17.45 20H16Z' fill='#323232'/></svg>
	</i>
</template>

<script>
export default {
	name: `b-new-b-icon-grid-off`,
	components: {},
	computed: {},
	props: {
		spin: {
			type: Boolean,
			default: false
		}
	},
	mounted() {
		if(this.spin){
			this.$nextTick(() => this.$el.classList.add('spin'));
		}
	}
};
</script>

<style scoped lang="scss">
i {
	display: inline-block;
	vertical-align: middle;

	svg {
		width: 1em;
		height: auto;
		display: block;
	}

	*:not([fill='none']) {
		fill: currentColor;
	}
}

path.a {
	fill: none;
}

.spin {
	animation: rotation 2s infinite linear;
}

@keyframes rotation {
	from {
		transform: rotate(0deg);
	}
	to {
		transform: rotate(359deg);
	}
}
</style>

<docs>
    IconGridOff

    ```js
    <b-new-b-icon-grid-off />
    ```
</docs>


